const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/eCheckin/sections/components/metakat/Versicherung/GeburtsPaketFields.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mMetaKatDropDown } from '@cistec/common_web/modules/CIS4m/components/CIS4mMetaKatDropDown';
import { useCIS4FormMetaKatData } from 'App/store/cis4m';
import { TextInput } from '@cistec/common_web/utils/intlUtils';
import { useIntl } from 'react-intl';

export type MaternityPackageCoverage = 'allgemein' | 'privat' | 'halbPrivat';

interface Props {
    label: TextInput;
    path: string;
    coverage: MaternityPackageCoverage | undefined;
    hidden?: boolean;
    required?: boolean;
}

const ICODE_GEBURTSPAKET_PRIVAT = '329c6a84-0944-4e47-9c75-a94aa706129e';
const ICODE_GEBURTSPAKET_HALBPRIVAT = 'dabd4f54-ea98-4e38-b5ee-87dc25ce8fb6';
const ICODE_GEBURTSPAKET_ALLGEMEIN = 'd063d10f-a91c-40ba-a96a-e91b5bc4351e';

export const GeburtsPaketFields = forwardRef((props: Props, ref: any) => {
    const dropdownRef = useCIS4m(ref);
    const { locale } = useIntl();

    const hidden = props.hidden ?? false;
    const required = props.required ?? false;
    let pcode: string;
    switch (props.coverage) {
        case 'privat':
            pcode = ICODE_GEBURTSPAKET_PRIVAT;
            break;
        case 'halbPrivat':
            pcode = ICODE_GEBURTSPAKET_HALBPRIVAT;
            break;
        case 'allgemein':
        default:
            pcode = ICODE_GEBURTSPAKET_ALLGEMEIN;
            break;
    }

    return (
        <CIS4mMetaKatDropDown
            ref={dropdownRef}
            label={props.label}
            path={props.path}
            pcode={pcode}
            valuePath="FKEY"
            labelPath={`CONTENT.Lang.${locale}`}
            hidden={hidden}
            required={required}
            dataHook={useCIS4FormMetaKatData}
        />
    );
});

GeburtsPaketFields.displayName = 'GeburtsPaketFields';
